import React from 'react';
import ProductPageTemplate from './ProductPageTemplate';
import {
  ForwardingIcon,
  Tracking,
  Workflow,
  Notifications,
  DocWorkflow,
  Generation,
  Transmission,
  Editor,
} from '../../assets';

const ForwardingPageUS = () => {
  const productData = {
    productName: 'Forwarding',
    tagline: 'Freight Forwarding Software for US NVOCCs and 3PLs',
    metaDescription: 'Freight forwarding ERP for US NVOCCs, 3PLs, and freight forwarders: air & ocean FCL/LCL, one-click AWB & BL generation, real-time tracking, and integrated finance in one platform.',
    description: 'End-to-end freight ERP for US freight forwarders and NVOCCs: managing air and ocean operations, one-click documentation, shipment tracking, and integrated finance from inquiry to invoice in a single platform.',
    icon: ForwardingIcon,
    pageUrlOverride: 'https://shipmnts.com/us/products/forwarding',
    currency: 'USD',
    features: [
      {
        title: 'Multimodal Tracking Automation',
        description: 'Track air, ocean FCL/LCL, and inland shipments with automated milestone updates across all US and global ports.',
        image: Tracking,
      },
      {
        title: 'Workflow & Milestone Management',
        description: 'Define custom workflows and track milestones for every shipment: from booking through delivery and invoicing.',
        image: Workflow,
      },
      {
        title: 'Single-Click Multichannel Notifications',
        description: 'Keep customers updated with automated email, SMS, and WhatsApp alerts at every shipment milestone.',
        image: Notifications,
      },
      {
        title: 'Document-Level Workflow for Forwarding & NVO',
        description: 'Manage House and Master documentation workflows for both forwarding and NVOCC operations.',
        image: DocWorkflow,
      },
      {
        title: 'Real-Time Document Editor',
        description: 'Edit shipping documents in real time with built-in validation: no back-and-forth with separate document tools.',
        image: Editor,
      },
      {
        title: 'Single-Click Multimodal Document Generation',
        description: 'Generate HBL, MBL, AWB, and other documents with one click: automatically populated from shipment data.',
        image: Generation,
      },
      {
        title: 'In-App E-AWB Transmission',
        description: 'Transmit electronic air waybills directly to the airline from within Shipmnts: no third-party tools required.',
        image: Transmission,
      },
    ],
    faqs: [
      {
        question: 'Is Shipmnts suitable for US freight forwarders and NVOCCs?',
        answer: 'Yes. Shipmnts supports US NVOCCs, 3PLs, and freight forwarders managing air and ocean freight. It covers the full inquiry-to-invoice workflow: operations, documentation, tracking, and finance: in one platform.',
      },
      {
        question: 'Does Shipmnts support US customs filing (AMS/ISF)?',
        answer: 'Not yet. AMS and ISF 10+2 filing is on the Shipmnts roadmap for 2026. US-based freight forwarders can use Shipmnts for operations, documentation, and finance today, and will need a separate tool for US customs filing until the 2026 launch.',
      },
      {
        question: 'Which US ports does Shipmnts support?',
        answer: 'Shipmnts supports all ports globally with no port-specific restrictions: including Los Angeles, Long Beach, New York/New Jersey, Savannah, Houston, and all other US ports of entry.',
      },
      {
        question: 'Can I generate HBL, MBL, and AWB documents from Shipmnts?',
        answer: 'Yes. Shipmnts supports one-click generation of House Bills of Lading (HBL), Master Bills of Lading (MBL), Air Waybills (AWB), delivery orders, and other shipping documents: auto-populated from shipment records.',
      },
      {
        question: 'Is Shipmnts suitable for NVOCCs operating from the US?',
        answer: 'Yes. Shipmnts supports NVOCC operations with document-level workflows for House and Master documentation, separate handling for agent and shipper relationships, and integrated finance for multi-party billing.',
      },
    ],
  };

  return <ProductPageTemplate {...productData} />;
};

export default ForwardingPageUS;
